import set from 'lodash/set';
import unset from 'lodash/unset';
import isEmpty from 'lodash/isEmpty';

window.queryString = require('query-string');

window.addQueryParam = function(key,value){
    let obj = window.queryString.parse(location.search);

    set(obj,[key],value);

    let query_string = '?' + window.queryString.stringify(obj);

    if (history.pushState) {
        var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + query_string + window.location.hash;
        window.history.pushState({path:newurl},'',newurl);
    }
};
window.removeQueryParam = function(key){
    let obj = window.queryString.parse(location.search);

    unset(obj,[key]);

    let query_string = isEmpty(obj) ? '' : '?' + window.queryString.stringify(obj);

    if (history.pushState) {
        var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + query_string + window.location.hash;
        window.history.pushState({path:newurl},'',newurl);
    }
};

